var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 3,
    fill: "#2D3D95"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_0_5893",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8261 4C8.46436 4 5.73914 6.72522 5.73914 10.087V12.1795C5.73914 13.2798 5.03006 14.2422 4.46647 15.1872C4.1702 15.684 4 16.2647 4 16.8851C4 18.488 5.1452 19.8633 6.73291 20.0834C8.3096 20.3021 10.2797 20.522 11.8261 20.522C13.3724 20.522 15.3426 20.3021 16.9193 20.0834C18.507 19.8633 19.6522 18.488 19.6522 16.8851C19.6522 16.2647 19.482 15.684 19.1857 15.1872C18.6221 14.2422 17.9131 13.2798 17.9131 12.1795V10.087C17.9131 6.72522 15.1878 4 11.8261 4Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8261 4C8.46436 4 5.73914 6.72522 5.73914 10.087V12.1795C5.73914 13.2798 5.03006 14.2422 4.46647 15.1872C4.1702 15.684 4 16.2647 4 16.8851C4 18.488 5.1452 19.8633 6.73291 20.0834C8.3096 20.3021 10.2797 20.522 11.8261 20.522C13.3724 20.522 15.3426 20.3021 16.9193 20.0834C18.507 19.8633 19.6522 18.488 19.6522 16.8851C19.6522 16.2647 19.482 15.684 19.1857 15.1872C18.6221 14.2422 17.9131 13.2798 17.9131 12.1795V10.087C17.9131 6.72522 15.1878 4 11.8261 4Z",
    fill: "url(#paint0_linear_0_5893)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16.8851H3.75H4ZM6.73291 20.0834L6.76725 19.8358H6.76725L6.73291 20.0834ZM16.9193 20.0834L16.8849 19.8358L16.9193 20.0834ZM4.46647 15.1872L4.25175 15.0592L4.46647 15.1872ZM5.98914 10.087C5.98914 6.86329 8.60243 4.25 11.8261 4.25V3.75C8.32629 3.75 5.48914 6.58715 5.48914 10.087H5.98914ZM5.98914 12.1795V10.087H5.48914V12.1795H5.98914ZM4.25 16.8851C4.25 16.311 4.40737 15.7744 4.68118 15.3153L4.25175 15.0592C3.93304 15.5936 3.75 16.2184 3.75 16.8851H4.25ZM6.76725 19.8358C5.3089 19.6336 4.25 18.3691 4.25 16.8851H3.75C3.75 18.607 4.9815 20.093 6.69857 20.3311L6.76725 19.8358ZM11.8261 20.272C10.2979 20.272 8.3419 20.0542 6.76725 19.8358L6.69857 20.3311C8.27729 20.55 10.2616 20.772 11.8261 20.772V20.272ZM16.8849 19.8358C15.3103 20.0542 13.3543 20.272 11.8261 20.272V20.772C13.3906 20.772 15.3749 20.55 16.9536 20.3311L16.8849 19.8358ZM19.4022 16.8851C19.4022 18.3691 18.3433 19.6336 16.8849 19.8358L16.9536 20.3311C18.6707 20.093 19.9022 18.607 19.9022 16.8851H19.4022ZM18.971 15.3153C19.2448 15.7744 19.4022 16.311 19.4022 16.8851H19.9022C19.9022 16.2184 19.7191 15.5936 19.4004 15.0592L18.971 15.3153ZM17.6631 10.087V12.1795H18.1631V10.087H17.6631ZM11.8261 4.25C15.0498 4.25 17.6631 6.86329 17.6631 10.087H18.1631C18.1631 6.58715 15.3259 3.75 11.8261 3.75V4.25ZM19.4004 15.0592C19.1096 14.5715 18.804 14.1153 18.5617 13.63C18.3227 13.1512 18.1631 12.6754 18.1631 12.1795H17.6631C17.6631 12.7839 17.8579 13.3395 18.1144 13.8533C18.3675 14.3605 18.6982 14.8579 18.971 15.3153L19.4004 15.0592ZM5.48914 12.1795C5.48914 12.6754 5.32945 13.1512 5.09047 13.6299C4.84821 14.1153 4.54258 14.5715 4.25175 15.0592L4.68118 15.3153C4.95395 14.8579 5.28465 14.3604 5.53783 13.8532C5.79428 13.3395 5.98914 12.7839 5.98914 12.1795H5.48914Z",
    fill: "url(#paint1_linear_0_5893)",
    fillOpacity: 0.7,
    mask: "url(#path-2-inside-1_0_5893)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdi_0_5893",
    x: 0,
    y: 0,
    width: 23.6523,
    height: 24.522,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_5893"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_0_5893",
    result: "effect2_dropShadow_0_5893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_5893",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_0_5893"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_5893",
    x1: -1.08696,
    y1: -2.60878,
    x2: 29.2473,
    y2: 23.0218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344EA6",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#587EFF",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#829EFF",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_5893",
    x1: 4.3913,
    y1: 6.47829,
    x2: 18.7086,
    y2: 18.1042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.adc428abc75e38bb23ebe6ade0732369.svg";
export { ForwardRef as ReactComponent };